import React, { useEffect } from 'react';
import './SidePanel.css';

const SidePanel = ({ open, title, onClose, children }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <>
      {open && <div className="sp-overlay" onClick={onClose} />}
      <div className={`sp-panel${open ? ' sp-panel--open' : ''}`}>
        <div className="sp-hd">
          <span className="sp-title">{title}</span>
          <button className="sp-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="sp-body">{children}</div>
      </div>
    </>
  );
};

export default SidePanel;
